const GAP = /insufficient current intelligence|data unavailable|assessment pending|^n\/?a$/i;

const hasContent = (value: unknown): boolean =>
    typeof value === 'string' && value.trim().length > 30 && !GAP.test(value);

export function cleanCountryAssessments<T extends Record<string, any>>(report: T): T {
    if (report?.carverAssessment) {
        const fields = ['criticality', 'accessibility', 'recuperability', 'vulnerability', 'effect', 'recognizability'];
        if (fields.filter(field => hasContent(report.carverAssessment[field])).length < 4 || !hasContent(report.carverAssessment.overallAssessment))
            delete report.carverAssessment;
    }
    if (report?.ascope) {
        const fields = ['areas', 'structures', 'capabilities', 'organizations', 'people', 'events'];
        if (fields.filter(field => hasContent(report.ascope[field])).length < 4)
            delete report.ascope;
    }
    return report;
}
